import React, { useEffect, useState } from 'react';

import { formatFigure, formatSeparateByThousands } from 'Helpers/formatService';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';
import CheckCircleIcon from 'Assets/icons/circle-check.svg';
import CircleXMark from 'Assets/icons/circle-xmark.svg';

export const SeatKillsTableSportVenueRow = (props) => {
    const [venueData, setVenueData] = useState(props.data);
    const [initData, setInitData] = useState(props.data);

    useEffect(() => {
        setVenueData(props.data);
        setInitData(props.data);
    }, [props.data]);

    useEffect(() => {
        if (props.edited) {
            const initialValues = JSON.parse(JSON.stringify(initData));
            setVenueData(initialValues);
        }
    }, [props.edited]);

    const categoryTotal = (category) => {
        return props.calculateCategoryTotal(category, props.edited ? venueData : initData);
    };

    const netCapacity = () => {
        return props.calculateNetCapacity(props.edited ? venueData : initData);
    };

    const onCancel = () => {
        const initialValues = JSON.parse(JSON.stringify(initData));
        setVenueData(initialValues);
        props.cancelEdit();
    };

    const onSave = () => {
        const { total: _killTotal, ...kills } = venueData.kills;
        const { total: _holdTotal, ...holds } = venueData.holds;
        const killsArray = Object.values(kills);
        const holdsArray = Object.values(holds);

        const data = {
            sport_id: props.data.sport_id,
            venue_id: props.data.venue_id,
            kills: killsArray.concat(holdsArray),
        };

        props.onSave(data).then(() => {
            setInitData(venueData);
        });
    };

    const handleChange = (e, group, catId) => {
        const { value } = e.target;
        const parsed = parseInt(value, 10);
        const val = Number.isNaN(parsed) ? 0 : parsed;
        const datum = JSON.parse(JSON.stringify(venueData));
        datum[group][catId].number = val;
        setVenueData(datum);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSave();
        } else if (e.key === 'Escape') {
            onCancel();
        }
    };

    return (
        <tr onDoubleClick={props.editRow}>
            <td>{props.data.sport_name}</td>
            <td
                className={props.hasSchedules ? 'tw-cursor-pointer' : ''}
                onClick={() => {
                    if (props.hasSchedules) {
                        props.toggleExpanded('venue', props.eventData.id, props.venueData.id);
                    }
                }}
            >
                <div className="tw-flex tw-items-center tw-gap-x-1.5">
                    <div>{props.data.venue_name}</div>
                    {props.hasSchedules && <div>{props.venueExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>}
                </div>
            </td>
            <td className="inbud-numeric-cell">{formatFigure(props.data.temp_capacity, formatSeparateByThousands, { precision: 3 })}</td>
            <td className="inbud-numeric-cell">{formatFigure(props.data.permanent_capacity, formatSeparateByThousands, { precision: 3 })}</td>
            <td className="inbud-numeric-cell">{formatFigure(props.data.capacity, formatSeparateByThousands, { precision: 3 })}</td>
            {props.categories.kills.map((item) => {
                const catId = item.id;

                return (
                    <td key={`${props.data.sport_id}_${props.data.venue_id}_${item.id}`} className="!tw-bg-white">
                        {!props.edited && (
                            <div className="inbud-numeric-cell">
                                {formatFigure(initData.kills[catId]?.number ?? 0, formatSeparateByThousands, { precision: 3 })}
                            </div>
                        )}
                        {!!props.edited && (
                            <input
                                type="number"
                                step="1"
                                name={`event_${props.data.sport_id}_venue_${props.data.venue_id}_cat_${catId}_row_edit`}
                                className="tw-block tw-w-full tw-min-w-14 tw-rounded-lg tw-text-sm tw-bg-grey/25 -tw-my-1 tw-px-2 tw-py-1 tw-text-charcoal focus:tw-outline-0"
                                id={`event_${props.data.sport_id}_venue_${props.data.venue_id}_cat_${catId}_row_edit`}
                                placeholder="0"
                                value={venueData.kills[catId]?.number || ''}
                                onChange={(e) => handleChange(e, 'kills', catId)}
                                onKeyDown={handleKeyDown}
                            />
                        )}
                    </td>
                );
            })}
            <td className="inbud-numeric-cell">{formatFigure(categoryTotal('kills'), formatSeparateByThousands, { precision: 3 })}</td>
            {props.categories.holds.map((item) => {
                const catId = item.id;

                return (
                    <td key={`${props.data.sport_id}_${props.data.venue_id}_${item.id}`} className="!tw-bg-white">
                        {!props.edited && (
                            <div className="inbud-numeric-cell">
                                {formatFigure(initData.holds[catId]?.number ?? 0, formatSeparateByThousands, { precision: 3 })}
                            </div>
                        )}
                        {!!props.edited && (
                            <input
                                type="number"
                                step="1"
                                name={`event_${props.data.sport_id}_venue_${props.data.venue_id}_cat_${catId}_row_edit`}
                                className="tw-block tw-w-full tw-min-w-14 tw-rounded-lg tw-text-sm tw-bg-grey/25 -tw-my-1 tw-px-2 tw-py-1 tw-text-charcoal focus:tw-outline-0"
                                id={`event_${props.data.sport_id}_venue_${props.data.venue_id}_cat_${catId}_row_edit`}
                                placeholder="0"
                                value={venueData.holds[catId]?.number || ''}
                                onChange={(e) => handleChange(e, 'holds', catId)}
                                onKeyDown={handleKeyDown}
                            />
                        )}
                    </td>
                );
            })}
            <td className="inbud-numeric-cell">{formatFigure(categoryTotal('holds'), formatSeparateByThousands, { precision: 3 })}</td>
            <td className="inbud-numeric-cell">{formatFigure(categoryTotal('all'), formatSeparateByThousands, { precision: 3 })}</td>
            <td className="inbud-numeric-cell">{formatFigure(netCapacity(), formatSeparateByThousands, { precision: 3 })}</td>
            {props.showActions && (
                <td>
                    {props.edited && (
                        <div className="tw-flex tw-justify-center tw-gap-2">
                            <button
                                type="button"
                                onClick={onSave}
                                className="tw-p-2 tw-rounded tw-bg-green-500 tw-text-white tw-hover:bg-green-600 tw-transition-colors"
                                title="Save changes"
                            >
                                <CheckCircleIcon className="tw-w-4 tw-h-4" />
                            </button>
                            <button
                                type="button"
                                onClick={onCancel}
                                className="tw-p-2 tw-rounded tw-bg-gray-500 tw-text-white tw-hover:bg-gray-600 tw-transition-colors"
                                title="Cancel changes"
                            >
                                <CircleXMark className="tw-w-4 tw-h-4" />
                            </button>
                        </div>
                    )}
                </td>
            )}
        </tr>
    );
};
